import { readFile } from '@shopify/cli-kit/node/fs';
import { joinPath } from '@shopify/cli-kit/node/path';
import { renderWarning } from '@shopify/cli-kit/node/ui';
import { outputDebug } from '@shopify/cli-kit/node/output';
import semver from 'semver';

const REACT_ROUTER_PACKAGES = [
  "react-router",
  "react-router-dom",
  "@react-router/dev",
  "@react-router/fs-routes"
];
const EXPECTED_VERSION = "7.9.2";
async function checkReactRouterVersions(appPath) {
  const mismatches = [];
  const packageJsonPath = joinPath(appPath, "package.json");
  let packageJson;
  try {
    packageJson = JSON.parse(await readFile(packageJsonPath));
  } catch (error) {
    outputDebug(
      `Unable to read package.json for React Router version check: ${error}`
    );
    return;
  }
  const allDeps = {
    ...packageJson.dependencies,
    ...packageJson.devDependencies,
    ...packageJson.peerDependencies
  };
  for (const pkg of REACT_ROUTER_PACKAGES) {
    const installedVersion = allDeps[pkg];
    if (!installedVersion) {
      continue;
    }
    installedVersion.replace(/^[\^~]/, "");
    if (!semver.satisfies(EXPECTED_VERSION, installedVersion)) {
      mismatches.push({
        package: pkg,
        installed: installedVersion,
        expected: EXPECTED_VERSION
      });
    }
  }
  if (mismatches.length > 0) {
    const mismatchList = mismatches.map(
      (m) => `  \u2022 ${m.package}: installed ${m.installed}, expected ${m.expected}`
    ).join("\n");
    const devPackages = ["@react-router/dev", "@react-router/fs-routes"];
    const regularMismatches = mismatches.filter(
      (m) => !devPackages.includes(m.package)
    );
    const devMismatches = mismatches.filter(
      (m) => devPackages.includes(m.package)
    );
    const commands = [];
    if (regularMismatches.length > 0) {
      const regularList = regularMismatches.map((m) => `${m.package}@${EXPECTED_VERSION}`).join(" ");
      commands.push(`npm install ${regularList}`);
    }
    if (devMismatches.length > 0) {
      const devList = devMismatches.map((m) => `${m.package}@${EXPECTED_VERSION}`).join(" ");
      commands.push(`npm install -D ${devList}`);
    }
    renderWarning({
      headline: "React Router version mismatch detected",
      body: [
        "Hydrogen requires React Router 7.9.x for proper functionality.",
        "",
        "Version mismatches found:",
        mismatchList,
        "",
        "To fix this issue, run:",
        ...commands.map((cmd) => `  ${cmd}`),
        "",
        "This may cause issues with routing, code splitting, and other features."
      ].join("\n")
    });
  }
}

export { checkReactRouterVersions };
